"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ l(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 4.884A1.63 1.63 0 0 1 4.873 3.25h14.232a1.63 1.63 0 0 1 1.623 1.634v14.232a1.63 1.63 0 0 1-1.623 1.634H4.873a1.63 1.63 0 0 1-1.623-1.634zM4.873 22h14.232a2.88 2.88 0 0 0 2.873-2.884V4.884A2.88 2.88 0 0 0 19.105 2H4.873A2.88 2.88 0 0 0 2 4.884v14.232A2.88 2.88 0 0 0 4.873 22m5.616-11.774c-.425.242-1.004.573-.855 1.168.167 1.003 1.924 2.76 3.01 3.011.512.073.832-.429 1.127-.891l.128-.197c.168-.25.335-.25.669-.167.334.126.668.293 1.003.46s.668.335 1.003.46l.002.003c.084.083.166.166.249.332.084 1.254-.836 2.09-1.922 2.341-3.345.67-8.363-4.349-7.694-7.694.25-1.087 1.17-2.007 2.34-1.84.168 0 .25.083.334.167l.002.001c.125.376.292.71.46 1.045.167.335.334.67.46 1.045.167.251.084.502-.167.67z",
        clipRule: "evenodd"
      }
    )
  }
), i = e(r);
export {
  i as Call,
  i as default
};
